import Sider from "antd/es/layout/Sider";
import {Badge, Button, Card, Col, Collapse, Divider, Drawer, Dropdown, Menu, Row, Space, Upload} from "antd";
import {CloseOutlined, PlusOutlined} from "@ant-design/icons";
import React, {Fragment, useEffect, useState} from "react";
import CollapsePanel from "antd/es/collapse/CollapsePanel";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {
    globalBrandConfigState,
    globalColorThemeState,
    globalCurrentPathState,
    globalLanguageListState,
    globalNotificationState,
    globalOpenGoLiveModalState,
    globalUnreadAnnouncementCountState,
    globalUnreadPushNotificationCountState,
    globalUserDetailState
} from "../../../_common/global_state";
import {useNavigate} from "react-router-dom";
import {withFreshToken} from "../../../router/sidebarRoute";
import useShared from "../../../_common/_shared";
import {useTranslation} from "react-i18next";
import useLayoutFunction from "../../function";
import {useVerification} from "../../../_common/_authorize";
import {getPlatform} from "../../../api/graphql/platformDownload";
import FooterTime from "./latestTime/footerTime";
import Meta from "antd/es/card/Meta";
import Avatar from "antd/es/avatar/avatar";
import dummyImg from "../../../assets/image/dummy.png";
import {useIsMobile} from "../../../_common/function";
import EWalletCard from "../../../../brand/component/eWalletCard";
import GoLiveModal from "./goLive";
import PlatformDownloadModal from "./platformDownload";
import {useProfileFunction} from "../../../pages/profile/function";
import Announcement_5 from "../../../pages/announcement/view/layout_5";
import {getUserAnnouncementUnreadCount} from "../../../api/graphql/announcement";

const Sider_5 = ({routes, collapsed, onCollapsedChange, setOpenQrModal, registerField, setCollapsed}) => {
    const {t} = useTranslation()
    const navigate = useNavigate();
    const {updateProfile} = useProfileFunction()
    const {IconCommon, IconFlag} = useShared();
    const {changeLanguageHandler, processRoute} = useLayoutFunction()
    const {handleTokenExpiration} = useVerification();
    const isMobile = useIsMobile(768);

    const [nav, setNav] = useState([]);
    const [platformData, setPlatformData] = useState([]);
    const [openDownloadModal, setOpenDownloadModal] = useState(false);
    const [openAnnouncementDrawer, setOpenAnnouncementDrawer] = useState(false);

    const setNotificationMessage = useSetRecoilState(globalNotificationState);
    const userDetails = useRecoilValue(globalUserDetailState);
    const languageListState = useRecoilValue(globalLanguageListState);
    const globalPathState = useRecoilValue(globalCurrentPathState);
    const brandConfigState = useRecoilValue(globalBrandConfigState)
    const unreadPushNotificationCount = useRecoilValue(globalUnreadPushNotificationCountState);
    const [openGoLiveModal, setOpenGoLiveModal] = useRecoilState(globalOpenGoLiveModalState);
    const [colorState, setColorState] = useRecoilState(globalColorThemeState);
    const [unreadAnnouncementCount, setUnreadAnnouncementCount] = useRecoilState(globalUnreadAnnouncementCountState);

    const userId = localStorage.getItem("userid")
    const currentLanguageObj = languageListState?.find((lang) => lang?.code === localStorage.getItem("language"));

    const uploadImage = async (e) => {
        const link = e?.file?.response?.data?.[0]
        if (link) {
            await updateProfile(userDetails?._id, {
                profileImage: link.toString(),
            })
        }
    }

    function filterAndGroupServers(arr) {
        const result = {};
        let appObject = null;

        for (const obj of arr) {
            const serverName = obj?.server?.name;
            const isEnabled =
                obj?.windowLinkObject.isEnabled ||
                obj?.macOSXLinkObject.isEnabled ||
                obj?.androidAPKLinkObject.isEnabled ||
                obj?.iOSDownloadLinkObject.isEnabled ||
                obj?.androidDownloadLinkObject.isEnabled ||
                obj?.huaweiDownloadLinkObject.isEnabled;

            if (obj.type === "app" && isEnabled) {
                appObject = obj;
            }

            if (serverName && isEnabled) {
                result[serverName] = obj;
            }
        }

        if (appObject) {
            result["App"] = appObject;
        }

        return result;
    }

    const preload = async () => {
        const unreadCount = await getUserAnnouncementUnreadCount(userId);
        setUnreadAnnouncementCount(unreadCount?.getUserAnnouncementByUserId?.unreadTotal);
        const response = await getPlatform();
        const filtered = await filterAndGroupServers(response?.getPlatform?.data);
        setPlatformData(filtered);
    };

    const languageDropdown = (
        <Menu
            className={"language-dropdown-menu"}
            selectedKeys={[localStorage.getItem("language")]}
        >
            {languageListState?.map((lang) => (
                <Menu.Item
                    key={lang?.code}
                    value={lang?.code}
                    onClick={() => changeLanguageHandler(lang?.code)}
                >
                    <Space>
                        <IconFlag countryCode={lang?.countryCode} className={"w-6"}/>
                        {lang?.nativeName}
                    </Space>
                </Menu.Item>
            ))}
        </Menu>
    );

    useEffect(() => {
        preload();
        processRoute(routes, setNav);
    }, [routes]);

    return (
        <Sider
            width={isMobile ? "100%" : 240}
            id={"layout-sider"}
            breakpoint={"lg"}
            collapsedWidth="0"
            collapsible
            collapsed={collapsed}
        >
            {isMobile && (
                <div className="nav-close-button text-end p-4 pb-0">
                    <Button
                        type={"text"}
                        icon={<CloseOutlined/>}
                        onClick={() => onCollapsedChange(!collapsed)}
                    />
                </div>
            )}
            <div className={"user-detail-container mt-6"}>
                <Card>
                    <Meta
                        avatar={
                            <Upload
                                name={"files"}
                                action={`${brandConfigState?.assetsURL}/api/upload/file`}
                                data={{
                                    brand: brandConfigState?.assetsBrandName,
                                    category: "profile"
                                }}
                                showUploadList={false}
                                beforeUpload={(file) => {
                                    const isImage = file.type?.includes("image")
                                    if (!isImage) {
                                        setNotificationMessage({
                                            status: "error",
                                            title: "",
                                            msg: t("errorMsg.type.invalidFileType"),
                                            key: "invalidFileType",
                                        });
                                    }
                                    return isImage || Upload.LIST_IGNORE;
                                }}
                                accept={"image/*"} maxCount={1}
                                onChange={uploadImage}
                                className={"upload-profile-image"}
                            >
                                <Avatar className={"profile-image"} src={userDetails?.profileImage || dummyImg}/>
                                <div className={"plus-overlay"}>
                                    <PlusOutlined/>
                                </div>
                            </Upload>
                        }
                        title={userDetails?.username}
                        description={userDetails?.email}
                    />
                </Card>
            </div>
            {isMobile && (
                <div className={"p-6 py-0 mt-4"}>
                    <EWalletCard/>
                </div>
            )}
            <div className={"nav-container py-4"}>
                {!!nav?.length && nav?.map((d, i) => (
                    <Fragment key={d.groupName}>
                        <div className="nav-group-title flex my-2">
                            <p><small className={"secondary-text title"}>{d.label}</small></p>
                            {d?.groupName === "pinned" && (
                                <a
                                    className={"tertiary_btn ms-auto"}
                                    onClick={() => {
                                        navigate("/profile?edit=true");
                                        if (isMobile) setCollapsed(true)
                                    }}
                                >
                                    <IconCommon className={"small-icon"} iconName={"cm-edit-regular"}/>
                                </a>
                            )}
                        </div>
                        <div className={`nav-item-container ${i === 1 ? "scrollable" : ""}`}>
                            {d?.items?.map((item, j) => item?.sub ? (
                                <Collapse key={j} ghost expandIconPosition={"end"}>
                                    <CollapsePanel
                                        key={j}
                                        header={
                                            <Fragment key={j}>
                                                <a
                                                    onClick={() => {
                                                        if (item?.path) {
                                                            item?.type === "_blank" ? window.open(withFreshToken(item?.path), "_blank") : navigate(item?.path)
                                                            if (isMobile) setCollapsed(true)
                                                        }
                                                    }}
                                                    className={`${globalPathState === item?.path ? "active" : ""} nav-item flex`}
                                                >
                                                    <div
                                                        className={"nav-item-icon me-2"}
                                                        style={{marginRight: "4px"}}
                                                    >
                                                        {item?.icon}
                                                    </div>
                                                    <div className={"ms-2"}>
                                                        {t(`module.${item.label.replace(".", "").replace(/[-\s+]/g, "_").toLowerCase()}`)}
                                                    </div>
                                                </a>
                                                {item.children ? (
                                                    <div
                                                        className={`nested-nav-item-container ${item.isExpanded ? "open" : ""}`}
                                                    >
                                                        <div>
                                                            {item.children?.map((c) => (
                                                                <a key={c.label} className="nav-item flex">
                                                                    <div className={"nav-item-icon"}>
                                                                        {c.icon}
                                                                    </div>
                                                                    <div className={"ms-2"}>
                                                                        {t(`module.${c.label.replace(".", "").replace(/[-\s+]/g, "_").toLowerCase()}`)}
                                                                    </div>
                                                                </a>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </Fragment>
                                        }
                                    >
                                        {item?.sub?.map((d, i) => (
                                            <Fragment key={i}>
                                                <a
                                                    onClick={() => {
                                                        if (d?.path) {
                                                            d?.type === "_blank" ? window.open(withFreshToken(d?.path), "_blank") : navigate(d?.path);
                                                            if (isMobile) setCollapsed(true)
                                                        }
                                                    }}
                                                    className={`${globalPathState === d?.path ? "active" : ""} nav-item flex `}
                                                >
                                                    <div className={"nav-item-icon me-2"}/>
                                                    <div className={"ms-2"}>
                                                        {t(`module.${d.label.replace(".", "").replace(/[-\s+]/g, "_").toLowerCase()}`)}
                                                    </div>
                                                </a>
                                            </Fragment>
                                        ))}
                                    </CollapsePanel>
                                </Collapse>
                            ) : (
                                <Fragment key={j}>
                                    <a
                                        onClick={() => {
                                            if (item?.path) {
                                                item?.type === "_blank" ? window.open(withFreshToken(item?.path), "_blank") : navigate(item?.path)
                                                if (isMobile) setCollapsed(true)
                                            }
                                        }}
                                        className={`${globalPathState === item?.path ? "active" : ""} nav-item flex`}
                                    >
                                        <div className={"nav-item-icon me-2"} style={{marginRight: "4px"}}>
                                            {item?.icon}
                                        </div>
                                        <div className={"ms-2"}>
                                            {t(`module.${item.label.replace(".", "").replace(/[-\s+]/g, "_").toLowerCase()}`)}
                                        </div>
                                    </a>
                                </Fragment>
                            ))}
                        </div>
                    </Fragment>
                ))}
                <div className={isMobile ? "block" : "block md:hidden"}>
                    <Divider/>
                    <Row>
                        <Dropdown
                            overlay={languageDropdown}
                            id={"language-select"}
                            getPopupContainer={(triggerNode) => triggerNode.parentElement}
                            arrow
                            placement={"top"}
                        >
                            <Col
                                flex={1}
                                className={"text-center"}
                                onClick={(e) => e?.preventDefault()}
                            >
                                <IconFlag
                                    countryCode={currentLanguageObj?.countryCode}
                                    className={"w-6"}
                                />
                            </Col>
                        </Dropdown>
                        <Col
                            flex={1}
                            className={"text-center"}
                        >
                            <div
                                className={"header-announcement"}
                                onClick={() => setOpenAnnouncementDrawer(true)}
                            >
                                <Badge
                                    count={unreadAnnouncementCount + unreadPushNotificationCount}
                                    size={"small"}
                                    color={"red"}
                                >
                                    <IconCommon
                                        iconName={"cm-notification-regular"}
                                        className={"w-6"}
                                    />
                                </Badge>
                            </div>
                        </Col>
                        <Col
                            flex={1}
                            className={"text-center"}
                            onClick={() => {
                                if (colorState === "light") {
                                    setColorState("dark");
                                    localStorage.setItem("color", "dark");
                                } else {
                                    setColorState("light");
                                    localStorage.setItem("color", "light");
                                }
                            }}
                        >
                            {colorState !== "light" ? (
                                <IconCommon
                                    iconName={"cm-darktheme-regular"}
                                    className={"toggleIcon w-6"}
                                />
                            ) : (
                                <IconCommon
                                    iconName={"cm-lighttheme-regular"}
                                    className={"toggleIcon w-6"}
                                />
                            )}
                        </Col>
                        <Col flex={1} className={"text-center"}>
                            <IconCommon
                                className={"w-6"}
                                iconName={"cm-qr-regular"}
                                onClick={() => setOpenQrModal(true)}
                            />
                        </Col>
                        <Col flex={1} className={"text-center"}>
                            <IconCommon
                                className={"w-6"}
                                iconName={"cm-logout-regular"}
                                onClick={() => handleTokenExpiration(true)}
                            />
                        </Col>
                    </Row>
                </div>
            </div>
            <div className={"mt-4 bottom-content-container"}>
                {userDetails?.clientAccountType === "demo" && (
                    <Button
                        block
                        type={"primary"}
                        className={"my-1"}
                        onClick={() => setOpenGoLiveModal(true)}
                    >
                        {t("common.goLive")}
                    </Button>
                )}
                <Button
                    block
                    className={"my-1"}
                    onClick={() => setOpenDownloadModal(true)}
                >
                    {t("common.download")}
                </Button>
                <div className={"text-center my-4"}>
                    <FooterTime/>
                </div>
            </div>
            <GoLiveModal
                isModalOpen={openGoLiveModal}
                handleCancel={() => setOpenGoLiveModal(false)}
                registerField={registerField}
            />
            <PlatformDownloadModal
                isModalOpen={openDownloadModal}
                handleCancel={() => setOpenDownloadModal(false)}
                platformData={platformData}
            />
            <Drawer
                getContainer={() => document.getElementById("layout-5")}
                open={openAnnouncementDrawer}
                onClose={() => setOpenAnnouncementDrawer(false)}
                width={"100%"}
            >
                <Announcement_5 isHeader/>
            </Drawer>
        </Sider>
    )
};

export default Sider_5